import { useMemo } from 'react';
import useIdentifyUser from './events/useIdentifyUser.hook';
import useInitAnalytics from './monitoring/useInitAnalytics.hook';
import useInitMonitoring from './monitoring/useInitMonitoring.hook';
import { useWebGLCheck } from './platform/use-webgl-check.hook';
import useInitPlatform from './platform/useInitPlatform.hook';
import useAntdLocale from './third-party/useAntdLocale.hook';
import useUpdateDayjsLocale from './third-party/useUpdateDayjsLocale.hook';
import useUpdateMomentLocale from './third-party/useUpdateMomentLocale.hook';

const useInfra = () => {
  useInitPlatform();
  useInitAnalytics();
  useIdentifyUser();
  useInitMonitoring();
  useWebGLCheck();

  useUpdateMomentLocale();
  useUpdateDayjsLocale();

  const locale = useAntdLocale();

  return useMemo(
    () => ({
      locale
    }),
    [locale]
  );
};

export default useInfra;
